import React, { useContext } from "react"
import { graphql } from 'gatsby'
import { FirebaseContext } from '../components/Firebase'

import SEO from "../components/seo"
import Hero from "../components/hero"
import Section from "../components/section"
import TestimonialsSection from "../components/testimonial"
import Domains from "../components/Domains"
import BenefitsSection from "../components/benefits"
import Banner from "../components/Banner"
const { cardData } = require('../static/testimonials')

export const query = graphql`
    {
      site {
        siteMetadata {
          title
          author
          siteUrl
          email
        }
      }
      domenii:allContentfulDomeniu(sort: {fields: ordine, order: ASC}) {
        nodes {
          nume
        }
  }

    mate:allContentfulFisa(filter: {curs: {elemMatch: {domeniuDezv: {elemMatch: {nume: {eq: "Matematica"}}}}}}) {
    totalCount
    distinct(field: curs___id)
  }
  cunoastereaMediului:allContentfulFisa(filter: {curs: {elemMatch: {domeniuDezv: {elemMatch: {nume: {eq: "Cunoașterea mediului"}}}}}}) {
    totalCount
    distinct(field: curs___id)
  }
  limbaj:allContentfulFisa(filter: {curs: {elemMatch: {domeniuDezv: {elemMatch: {nume: {eq: "Limbaj și Comunicare"}}}}}}) {
    totalCount
    distinct(field: curs___id)
  }
  estetic:allContentfulFisa(filter: {curs: {elemMatch: {domeniuDezv: {elemMatch: {nume: {eq: "Estetic și Creativ"}}}}}}) {
    totalCount
    distinct(field: curs___id)
  }
  socioEmotional:allContentfulFisa(filter: {curs: {elemMatch: {domeniuDezv: {elemMatch: {nume: {eq: "Socio-Emoțional"}}}}}}) {
    totalCount
    distinct(field: curs___id)
  }
  edFizica:allContentfulFisa(filter: {curs: {elemMatch: {domeniuDezv: {elemMatch: {nume: {eq: "Educație Fizică"}}}}}}) {
    totalCount
    distinct(field: curs___id)
  }
  ala:allContentfulFisa(filter: {curs: {elemMatch: {domeniuDezv: {elemMatch: {nume: {eq: "Activități Liber Alese"}}}}}}) {
    totalCount
    distinct(field: curs___id)
  }
  tranzitii:allContentfulFisa(filter: {curs: {elemMatch: {domeniuDezv: {elemMatch: {nume: {eq: "Rutine și Tranziții"}}}}}}) {
    totalCount
    distinct(field: curs___id)
  }
  pedagogie:allContentfulFisa(filter: {curs: {elemMatch: {domeniuDezv: {elemMatch: {nume: {eq: "Pedagogie"}}}}}}) {
    totalCount
    distinct(field: curs___id)
  }
    
}
`

const IndexPage = ({ data }) => {
  const { userAuth } = useContext(FirebaseContext);
  return (
    <section>
      <SEO title="Home" />
      <Banner/>
      <Hero/>
      <BenefitsSection />
      <Domains data={data} />
      <Section />
      {!userAuth && <TestimonialsSection cards={cardData} />}
    </section>
  )
}

export default IndexPage
